<template>
  <svg
    class="vt-ico" :class="'vt-ico--' + kind" :width="size" :height="size" viewBox="0 0 24 24" fill="currentColor"
    :aria-hidden="label ? null : 'true'" :role="label ? 'img' : null" :aria-label="label ? name : null" focusable="false"
  >
    <path :d="PATHS[kind]" />
  </svg>
</template>

<script>
import { visitKindOf, visitTypeLabel, kindLabel } from '@/utils/visitTypes'
// TB-121: visit type is never a colour. Same glyphs as the app (Material Design
// Icons 7.4.47, outline): office-building-outline, video-outline, home-outline.
const PATHS = {
  clinic: 'M19 3V21H13V17.5H11V21H5V3H19M15 7H17V5H15V7M11 7H13V5H11V7M7 7H9V5H7V7M15 11H17V9H15V11M11 11H13V9H11V11M7 11H9V9H7V11M15 15H17V13H15V15M11 15H13V13H11V15M7 15H9V13H7V15M15 19H17V17H15V19M7 19H9V17H7V19M21 1H3V23H21V1Z',
  video: 'M15,8V16H5V8H15M16,6H4A1,1 0 0,0 3,7V17A1,1 0 0,0 4,18H16A1,1 0 0,0 17,17V13.5L21,17.5V6.5L17,10.5V7A1,1 0 0,0 16,6Z',
  home: 'M12 5.69L17 10.19V18H15V12H9V18H7V10.19L12 5.69M12 3L2 12H5V20H11V14H13V20H19V12H22'
}

// TB-184: kind and names come from the admin-managed type (utils/visitTypes.js);
// the old title mapping is only its fallback.
export const VISIT_TYPE_NAME = {
  get clinic () { return kindLabel('clinic') },
  get video () { return kindLabel('video') },
  get home () { return kindLabel('home') }
}

export const visitKind = visitKindOf

export default {
  name: 'VisitTypeIcon',
  props: {
    type: { type: [String, Object], default: 'clinic' },
    size: { type: [Number, String], default: 14 },
    label: { type: Boolean, default: false }
  },
  data: () => ({ PATHS }),
  computed: {
    kind () { return visitKind(this.type) },
    name () { return visitTypeLabel(this.type) }
  }
}
</script>

<style scoped>
.vt-ico { flex: none; display: inline-block; vertical-align: -0.15em; }
</style>
